/* Lightweight native carousel and collection pagination helpers. */
(function () {
  'use strict';

  function initLogoSlider(slider) {
    if (slider.dataset.nativeSliderReady === 'true') return;
    slider.dataset.nativeSliderReady = 'true';

    var paused = false;
    var timer;

    function visibleSlides() {
      var width = window.innerWidth;
      if (width < 550) return 1;
      if (width < 768) return 2;
      if (width < 990) return 3;
      if (width < 1150) return 4;
      return 5;
    }

    function advance() {
      if (paused || document.hidden || slider.scrollWidth <= slider.clientWidth) return;

      var step = slider.clientWidth / visibleSlides();
      var end = slider.scrollWidth - slider.clientWidth;
      var next = slider.scrollLeft + step;

      slider.scrollTo({
        left: next >= end - 2 ? 0 : next,
        behavior: 'smooth'
      });
    }

    function start() {
      window.clearInterval(timer);
      timer = window.setInterval(advance, 1800);
    }

    slider.addEventListener('mouseenter', function () { paused = true; });
    slider.addEventListener('mouseleave', function () { paused = false; });
    slider.addEventListener('focusin', function () { paused = true; });
    slider.addEventListener('focusout', function () { paused = false; });
    slider.addEventListener('pointerdown', function () { paused = true; }, { passive: true });
    slider.addEventListener('pointerup', function () { paused = false; }, { passive: true });
    window.addEventListener('resize', start, { passive: true });
    start();
  }

  function initCollectionPagination(root) {
    root.addEventListener('click', function (event) {
      var link = event.target.closest('product-facet .pagination__nav-item');
      if (!link) return;

      var facet = document.getElementById('facet-main');
      if (!facet) return;

      window.setTimeout(function () {
        window.scrollTo({
          top: facet.getBoundingClientRect().top + window.scrollY - 140,
          behavior: 'smooth'
        });
      }, 0);
    });
  }

  function init() {
    document.querySelectorAll('.logo-slider').forEach(initLogoSlider);
    initCollectionPagination(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
